/* eslint-disable no-unused-vars */
import React, { useState, useEffect, useContext } from 'react';
import { withRouter, Switch, Route, Redirect } from 'react-router-dom';
import _ from 'lodash';
import { connect } from 'react-redux';
import ConfirmAlert from 'modules/common/components/ConfirmAlert';
import GenericListPair from 'modules/common/components/GenericListPair';
import { ModalContext } from 'App';
import PropTypes from 'prop-types';
import * as actions from '../action';
import * as c from '../constant';
import useDebounce from '../../../common/components/UseDebounce';
import MiniProgramGovContent from './MiniProgramGovContent';
import CreateModal from '../components/CreateModal';
import UpdateModal from '../components/UpdateModal';

const form = {
  keyword: '',
};

function MiniProgramGovContainer({
  match,
  history,
  getMiniProgramGovList,
  miniProgramGovList,
  miniProgramGovListPager,
  isLoading,
  removeMiniProgramGov,
  showMiniProgramGov
}) {

  const [formData, setFormData] = useState(form);
  const [filter, setFilter] = useState(form);
  const setModal = useContext(ModalContext);

  const handleOnChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleOnChangeSelect = (key) => (e) => {
    setFilter({
      ...filter,
      [key]: e.value,
      type: e.value,
    });
    getMiniProgramGovList({ ...filter, type: e.value, order_by: 'sequence' });
  };

  const handleAddModal = (e) => {
    e.preventDefault();
    setModal({
      isOpen: true,
      content: <CreateModal />,
      title: 'Add Mini Program Government Program',
      modalSize: 'modal-md',
    });
  };

  const handleEdit = (data) => (e) => {
    e.preventDefault();
    setModal({
      isOpen: true,
      content: <UpdateModal updateList={data.attributes} id={data.id} />,
      title: 'Update Mini Program Government Program',
      modalSize: 'modal-md',
    });
  };

  const handleRemove = (data) => (e) => {
    e.preventDefault();
    ConfirmAlert(
      'Are you sure, you want to remove this Mini Program Government Program?',
      () => {
        removeMiniProgramGov(data.id, () => {
          getMiniProgramGovList();
          const id = _.get(miniProgramGovList, '0.id');
          history.push(`/general-settings/mini-program-government/${id}`);
        });
      },
      () => {},
      {
        yesLabel: 'Confirm',
        noLabel: 'Cancel',
      }
    );
  };

  useEffect(() => {
    getMiniProgramGovList();
    return () => {
      setModal({ isOpen: false });
    };
  }, []);

  const debouncedSearchTerm = useDebounce(formData, 500);

  const param = {
    q: formData.keyword,
    sort_by: 'asc'
  };

  useEffect(() => {
    if (debouncedSearchTerm) {
      getMiniProgramGovList({ q: formData.keyword, order_by: 'sequence' });
    } else {
      setFormData([]);
    }
  }, [debouncedSearchTerm]);

  return (
    <div className="card-content-listing">
      <Route
        path={`${match.path}/:miniProgramGovId?`}
        render={({ match: { params } }) => (
          <GenericListPair
            moduleName="Mini Program Government List"
            getData={getMiniProgramGovList}
            setParams={param}
            setKeyword={handleOnChange}
            statusFilter
            statusOptions={c.GOV_TYPE_LIST}
            setStatusFilter={handleOnChangeSelect(
              _.get(formData, 'type')
            )}
            status={_.get(filter, 'type') || ''}
            keyword={_.get(formData, 'keyword') || ''}
            keywordPlaceholder="Search Government Programs..."
            pathName={`${match.path}/:miniProgramGovId?`}
            listName="modules"
            label="Mini Program Government Programs List"
            renderItem={(item) => (
              <div className="px-3 py-3">
                {_.get(item, 'attributes.name')}
              </div>
            )}
            isLoading={isLoading}
            selected={params.miniProgramGovId}
            data={miniProgramGovList}
            dataPager={miniProgramGovListPager}
            handleSelectRow={(data) => {
              history.push(`${match.url}/${_.get(data, 'id')}`);
            }}
            renderContent={() => (
              <React.Fragment>
                <Switch>
                  <Route
                    path={`${match.path}/:miniProgramGovId?`}
                    render={() => (
                      <MiniProgramGovContent
                        handleAddModal={handleAddModal}
                        handleEdit={handleEdit}
                        handleRemove={handleRemove}
                      />
                    )}
                  />
                </Switch>
                <Route
                  path={`${match.path}/:miniProgramGovId?`}
                  render={() =>
                    !params.miniProgramGovId && miniProgramGovList.length > 0 ? (
                      <Redirect
                        to={`${match.url}/${_.get(miniProgramGovList, '0.id')}`}
                      />
                    ) : null
                  }
                />
              </React.Fragment>
            )}
          />
        )}
      />
    </div>
  );
}

MiniProgramGovContainer.propTypes = {
  match: PropTypes.instanceOf(Object).isRequired,
  history: PropTypes.instanceOf(Object).isRequired,
  getMiniProgramGovList: PropTypes.instanceOf(Function).isRequired,
  miniProgramGovList: PropTypes.instanceOf(Array).isRequired,
  miniProgramGovListPager: PropTypes.instanceOf(Object).isRequired,
  removeMiniProgramGov: PropTypes.instanceOf(Function).isRequired,
  showMiniProgramGov: PropTypes.instanceOf(Function).isRequired,
  isLoading: PropTypes.bool.isRequired,
};

const mapStateToProps = ({ api }) => ({
  miniProgramGovList: _.get(api, `${c.GET_MINI_PROGRAM_GOV}.list`) || [],
  miniProgramGovListPager: _.get(api, `${c.GET_MINI_PROGRAM_GOV}.pager`) || {},
  isLoading: _.get(api, 'loading', []).indexOf(c.GET_MINI_PROGRAM_GOV) > -1,
});

const enhance = _.flowRight([withRouter, connect(mapStateToProps, actions)]);

export default enhance(MiniProgramGovContainer);
